export const ALL_CODES = [
  'OMNIVA',
  'OMNIVALV',
  'OMNIVASP',
  'OMNIVASPLV',
  'DPDET',
  'DPDSPET',
  'DPDLV',
  'DPDSPLV',
  'DPDLT',
  'DPDSPLT',
  'DPDSPFI',
  'DPDSPSE',
  'ITELLA',
  'ITELLASP',
  'POSTILV',
  'POSTISPLV',
  'POSTILT',
  'POSTISE',
  'POSTISPLT',
  'POSTISPSE',
  'POSTIFI',
  'POSTISPFI',
  'POSTISE',
  'POSTISPSE',
  'MATKAHUOLTOSPFI',
  'MATKAHUOLTOFI',
  'BUDBEESPFI',
  'BUDBEEFI',
  'INSTABOX',
  'INSTABOXHOME',
  'EKSPRESS',
  'EXPRESSP',
  'EXPRESSPFI',
  'VENIPAKEE',
  'VENIPAKLT',
  'VENIPAKLV',
  'VENIPAKSPEE',
  'VENIPAKSPLT',
  'VENIPAKSPLV',
] as const

export type KonakartCarrierCode =
  | 'OMNIVA'
  | 'OMNIVALV'
  | 'OMNIVASP'
  | 'OMNIVASPLV'
  | 'DPDET'
  | 'DPDSPET'
  | 'DPDLV'
  | 'DPDSPLV'
  | 'DPDLT'
  | 'DPDSPLT'
  | 'DPDSPFI'
  | 'DPDSPSE'
  | 'ITELLA'
  | 'ITELLASP'
  | 'POSTILV'
  | 'POSTISPLV'
  | 'POSTILT'
  | 'POSTISPLT'
  | 'POSTIFI'
  | 'POSTISPFI'
  | 'MATKAHUOLTOSPFI'
  | 'MATKAHUOLTOFI'
  | 'BUDBEESPFI'
  | 'BUDBEEFI'
  | 'INSTABOX'
  | 'INSTABOXHOME'
  | 'EKSPRESS'
  | 'EXPRESSP'
  | 'EXPRESSPFI'
  | 'VENIPAKEE'
  | 'VENIPAKLT'
  | 'VENIPAKLV'
  | 'VENIPAKSPEE'
  | 'VENIPAKSPLT'
  | 'VENIPAKSPLV'

export type ShippingCode =
  | 'table'
  | 'tableshippingclone'
  | 'tableomniva'
  | 'tableomnivalv'
  | 'tableshippingcloneitella'
  | 'tableshippingcloneitellaexpress'
  | 'tableshippingcloneomniva'
  | 'tableshippingcloneomnivalv'
  | 'tableshippingclonesbtl'
  | 'tabledpdspet'
  | 'tabledpdet'
  | 'tabledpdlv'
  | 'tabledpdsplv'
  | 'tabledpdlt'
  | 'tabledpdsplt'
  | 'instabox'
  | 'budbeefi'
  | 'budbeespfi'
  | 'tabletaxi'
  | 'tableexpressparcel'
  | 'tableexpressparcelfi'
  | 'postifi'
  | 'postilt'
  | 'postilv'
  | 'postise'
  | 'postispfi'
  | 'postisplt'
  | 'postisplv'
  | 'postispse'
  | 'venipakee'
  | 'venipaklt'
  | 'venipaklv'
  | 'venipakspee'
  | 'venipaksplt'
  | 'venipaksplv'

export interface ShippingQuote {
  code: ShippingCode
  moduleCode: ShippingCode
  description: string
  sortOrder: number
  title: string
  handlingCost: number
  tax: number
  responseText: 'Shipping'
  cost: number
  free: boolean
  taxClass: number
  totalExTax: number
  totalIncTax: number
  icon?: string
  custom1: KonakartCarrierCode // the added field
}
